module.exports = __webpack_public_path__ + "static/flags/LB-6fdcbbfbbd6851ca7e54ded37c179b73.gif";